export default {"src":"/_next/static/media/ticket.372803ef.svg","height":27,"width":41,"blurWidth":0,"blurHeight":0};